// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取公司配置 POST /common/company_config/get_company_config */
export async function postCommonCompanyConfigGetCompanyConfig(
  body: API.GetCompanyConfigParams,
  options?: { [key: string]: any },
) {
  return request<API.GetCompanyConfigResult>('/common/company_config/get_company_config', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取报单文案配置 POST /common/company_config/get_copy_text_config */
export async function postCommonCompanyConfigGetCopyTextConfig(
  body: API.GetCopyTextConfigParams,
  options?: { [key: string]: any },
) {
  return request<API.GetCopyTextConfigResult>('/common/company_config/get_copy_text_config', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取数量自定展示配置 POST /common/company_config/get_data_num_show */
export async function postCommonCompanyConfigGetDataNumShow(
  body: API.GetDataNumShowParams,
  options?: { [key: string]: any },
) {
  return request<API.GetDataNumShowResult>('/common/company_config/get_data_num_show', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取生产流程配置 POST /common/company_config/get_process_config */
export async function postCommonCompanyConfigGetProcessConfig(
  body: API.GetProcessConfigParams,
  options?: { [key: string]: any },
) {
  return request<API.GetProcessConfigResult>('/common/company_config/get_process_config', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取巧飞配置 POST /common/company_config/get_qf_config */
export async function postCommonCompanyConfigGetQfConfig(
  body: API.GetQfConfigParams,
  options?: { [key: string]: any },
) {
  return request<API.GetQfConfigResult>('/common/company_config/get_qf_config', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取用户筛选配置 POST /common/company_config/get_select_filter_config */
export async function postCommonCompanyConfigGetSelectFilterConfig(
  body: API.GetSelectFilterConfigParams,
  options?: { [key: string]: any },
) {
  return request<API.GetSelectFilterConfigResult>(
    '/common/company_config/get_select_filter_config',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 添加公司配置 POST /common/company_config/save_company_config */
export async function postCommonCompanyConfigSaveCompanyConfig(
  body: API.SaveCompanyConfigParams,
  options?: { [key: string]: any },
) {
  return request<API.SaveCompanyConfigResult>('/common/company_config/save_company_config', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 保存报单文案配置 POST /common/company_config/save_copy_text_config */
export async function postCommonCompanyConfigSaveCopyTextConfig(
  body: API.SaveCopyTextConfigParams,
  options?: { [key: string]: any },
) {
  return request<API.SaveCopyTextConfigResult>('/common/company_config/save_copy_text_config', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 保存生产流程配置 POST /common/company_config/save_process_config */
export async function postCommonCompanyConfigSaveProcessConfig(
  body: API.SaveProcessConfigParams,
  options?: { [key: string]: any },
) {
  return request<API.SaveProcessConfigResult>('/common/company_config/save_process_config', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 保存巧飞配置 POST /common/company_config/save_qf_config */
export async function postCommonCompanyConfigSaveQfConfig(
  body: API.SaveQfConfigParams,
  options?: { [key: string]: any },
) {
  return request<API.SaveQfConfigResult>('/common/company_config/save_qf_config', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 保存筛选用户配置 POST /common/company_config/save_select_filter_config */
export async function postCommonCompanyConfigSaveSelectFilterConfig(
  body: API.SaveSelectFilterConfigParams,
  options?: { [key: string]: any },
) {
  return request<API.SaveSelectFilterConfigResult>(
    '/common/company_config/save_select_filter_config',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}
